var render = function () {
  var _vm$list, _vm$list2, _vm$list3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "brands-select",
    class: [{
      'brands-select_search-progress': _vm.query
    }]
  }, [_c('div', {
    staticClass: "row-slider brands-select__row-slider"
  }, [(_vm$list = _vm.list) !== null && _vm$list !== void 0 && _vm$list.popular.length ? _c('RowSliderNew', {
    staticClass: "row-slider_brand",
    attrs: {
      "list": _vm.list.popular,
      "offset-between-elements": 15
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var el = _ref.el;
        return [_c('BrandEl', {
          key: el.id,
          attrs: {
            "brand": el,
            "size": "m",
            "data-e2e": "brandslogo"
          }
        })];
      }
    }], null, false, 3418200451)
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "brands-select__search-field"
  }, [_c('BrandSearchField', {
    staticClass: "brands-select__field",
    attrs: {
      "options": _vm.options,
      "list": (_vm$list2 = _vm.list) === null || _vm$list2 === void 0 ? void 0 : _vm$list2.groupped
    },
    on: {
      "search-result": _vm.getSearchResult,
      "input": _vm.input
    }
  })], 1), _vm._v(" "), _vm.query ? _c('div', [_vm.searchResult.length ? _c('div', {
    staticClass: "brands-select__grid"
  }, _vm._l(_vm.searchResult, function (brand) {
    return _c('div', {
      key: brand.item.id,
      staticClass: "brands-select__col",
      class: [{
        'brands-select__col_last': _vm.searchResult.length === 1
      }]
    }, [_c('div', {
      staticClass: "brands-select__col-wrap"
    }, [_c('div', {
      staticClass: "brands-select__list"
    }, [_c('a', {
      staticClass: "link link_wu brands-select__link",
      attrs: {
        "href": ("/brands/" + (brand.item.code || brand.item.id) + "/"),
        "data-e2e": "brandsearch"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.navigateTo(("/brands/" + (brand.item.code || brand.item.id) + "/"));
        }
      }
    }, [_vm._v("\n              " + _vm._s(brand.item.name) + "\n            ")])])])]);
  }), 0) : _c('div', {
    staticClass: "brands-select__search-empty"
  }, [_c('StatusBlock', {
    attrs: {
      "size": "l",
      "type": "empty",
      "title": "Бренд не найден",
      "description": "Проверьте, правильно ли вы ввели название."
    }
  })], 1)]) : _c('div', {
    staticClass: "brands-select__grid"
  }, _vm._l((_vm$list3 = _vm.list) === null || _vm$list3 === void 0 ? void 0 : _vm$list3.groupped, function (brand, index) {
    return _c('div', {
      key: index,
      staticClass: "brands-select__col"
    }, [brand.list.length ? _c('div', {
      staticClass: "brands-select__col-wrap"
    }, [_c('div', {
      staticClass: "brands-select__col-char"
    }, [_vm._v("\n          " + _vm._s(brand.char) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "brands-select__list"
    }, _vm._l(brand.list, function (item, i) {
      return _c('div', {
        key: i,
        staticClass: "brands-select__list-el"
      }, [_c('a', {
        staticClass: "link link_wu",
        attrs: {
          "href": ("/brands/" + (item.code || item.id) + "/"),
          "data-e2e": "brands"
        },
        on: {
          "click": function ($event) {
            $event.preventDefault();
            return _vm.navigateTo(("/brands/" + (item.code || item.id) + "/"));
          }
        }
      }, [_vm._v(_vm._s(item.name))])]);
    }), 0)]) : _vm._e()]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }